import { useMemo } from 'react'

import sanitizeHtml from 'sanitize-html'

const useLineBreakHtml = html =>
	useMemo(() => {
		if (!html) {
			return ''
		}

		return sanitizeHtml(html, {
			allowedTags: ['br'],
			allowedAttributes: false,
			allowVulnerableTags: false,
		})
	}, [html])

export default useLineBreakHtml
